import type { ApiGmapsType } from '../../../apps/api-hono/src/routes/gmaps/mapsRoute.controller'
import { hc } from 'hono/client'
import { getEnvVariable } from '@lib/utils/getEnvVariable';
import { getClientRequestOptions } from './getClientRequestOptions';

const client = hc<ApiGmapsType>('')
type Client = typeof client
const createGmapsApiClient = (...args: Parameters<typeof hc>): Client => {
    return hc<ApiGmapsType>(...args)
}

export const gmapsApiClient = createGmapsApiClient(
    `https://${getEnvVariable('PUBLIC_API_DOMAIN')}/gmaps/`,
    getClientRequestOptions()
)

